import script from "./ChannelMessagesTrendChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChannelMessagesTrendChart.vue?vue&type=script&lang=ts&setup=true"

import "./ChannelMessagesTrendChart.vue?vue&type=style&index=0&id=3724fc64&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3724fc64"]])

export default __exports__